"use client";
import { useSearchParams } from "next/navigation";
import { Box, IconButton, Stack } from "@mui/material";
import {
  ContentCopyRounded as CopyIcon,
  RestartAltRounded as ResetApiKey
} from "@mui/icons-material";

import { observer, useStore } from "../../service/mobx";
import { Section } from "./";
import ToolTip from "../../component/Tooltip";
import LongPressIconButton from "../../component/Button/LongPress";
import ButtonFilled from "../../component/Button/Filled";

function Key() {
  const { snackbar, model, user, utilities } = useStore();
  const returnTo = useSearchParams().get("returnTo");
  const noKey = model.notOnApiPlan;

  return (
    <Section title="Key" sx={{ m: "auto", mt: 4, maxWidth: 500 }}>
      <Stack
        spacing={2}
        p={1}
        pl={3}
        flexWrap="wrap"
        alignItems="center"
        justifyContent="space-between"
        borderRadius="var(--shape-xs-round)"
        bgcolor="var(--dark-surface-color)"
        color="var(--dark-primary-color)"
        overflow="hidden"
        textOverflow="ellipsis"
        direction="row"
      >
        <Stack direction="row" spacing={1} alignItems="center">
          {noKey ? null : (
            <ToolTip
              title={
                noKey ? "" : "Generate new API key - hold down for 5 seconds"
              }
              sx={{
                ml: -2,
                opacity: 0.3,
                transition: "all 500ms var(--motion-easing-emphasized)",
                "&:hover": {
                  opacity: 1
                }
              }}
            >
              <LongPressIconButton
                onLongPress={async () => {
                  await utilities.generateApiKey();

                  snackbar.notify({
                    text: "You now have a different API key"
                  });
                }}
              >
                <ResetApiKey sx={{ color: "var(--dark-surface-on-color)" }} />
              </LongPressIconButton>
            </ToolTip>
          )}
          <Box
            typography="code"
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
            maxWidth={{ compact: "20ch", medium: "100ch" }}
          >
            {user.loaded
              ? user.plan
                ? user.key
                : user.loggedIn
                ? "Next step: choose an API plan"
                : "Sign in for a free key"
              : "..."}
          </Box>
        </Stack>
        {noKey ? null : (
          <IconButton
            onClick={() => {
              navigator.clipboard.writeText(user.key);
              snackbar.notify({ text: "Copied to clipboard" });
            }}
          >
            <CopyIcon sx={{ color: "var(--dark-surface-on-color)" }} />
          </IconButton>
        )}
      </Stack>
      {user.loaded && user.isAnonymous ? (
        <ButtonFilled
          fullWidth
          size="large"
          label="Sign in"
          href={`/auth?returnTo=${encodeURIComponent(
            `/api/pricing${returnTo ? `?returnTo=${returnTo}` : ""}`
          )}`}
          sx={{
            borderRadius: "var(--shape-sm)",
            boxShadow: "var(--elevation-1)"
          }}
        />
      ) : null}
    </Section>
  );
}

export default observer(Key);
